import { render } from "./HomeView.vue?vue&type=template&id=703a2298&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=703a2298&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703a2298"]])

export default __exports__